import React from 'react'
import styles from './Quote.module.css'
interface IProps {
  quote: string,
  quoteSource: string
}
export const Quote: React.FC<IProps> = (props) => {

  const { quote, quoteSource } = props
  return (
    <React.Fragment>
      <div className={styles.quoteContent}>
        {
          quote.split('\n').map(p => (<div key={p}>{p}</div>))
        }
      </div>
      <div className={styles.quoteSource}>{quoteSource}</div>
    </React.Fragment>
  )
}